import { render } from "./TestView.vue?vue&type=template&id=c7471dda&scoped=true"
import script from "./TestView.vue?vue&type=script&lang=js"
export * from "./TestView.vue?vue&type=script&lang=js"

import "./TestView.vue?vue&type=style&index=0&id=c7471dda&scoped=true&lang=css"

import exportComponent from "C:\\Users\\47959\\OneDrive\\Documents\\GitHub\\Poesiparken\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7471dda"]])

export default __exports__